{
  "id": "print-pm",
  "label": "Print-pm",
  "planning": {
    "titlePattern": "TT:s print-pm {dayName} {date}",
    "slugline": "print-pm"
  },
  "sources": [
    { "type": "print-article", "flow": "Nyheter", "newsvalues": [], "leadDays": 1 },
    { "type": "article", "newsvalues": [] }
  ],
  "postamble": [],
  "requiresEditorialInfoType": true,
  "editorialInfoTypeMax": 3,
  "opensPlanning": true,
  "requiresItems": false,
  "memoTitlePattern": "{editorialInfoType} {dayName} {date}",
  "editorialInfoTypeHeadings": [
    {
      "types": ["PM BNL", "PM Gota", "PM NTM"],
      "memoTitlePattern": "PM TT:s in- och utrikessidor {dayName} {date} {editorialInfoTypeName}"
    },
    {
      "types": ["PM In-ut"],
      "memoTitlePattern": "PM TT:s in- och utrikessidor {dayName} {date}"
    }
  ],
  "insertsIntoEveryBlock": true,
  "blocks": [
    {
      "id": "uppslag",
      "label": "UPPSLAG",
      "preamble": [],
      "heading": "UPPSLAG",
      "grouping": "none",
      "keywords": [
        "TOPP",
        "BOTTEN",
        "SIDOTEXT",
        "NOTIS",
        "BILDNOTIS",
        "UTROPSTECKEN",
        "SIFFRA",
        "CITAT",
        "SPALTTEXT"
      ],
      "item": {
        "headline": "{keyword} {headline}",
        "lines": []
      }
    },
    {
      "id": "enkelsidan",
      "label": "ENKELSIDAN",
      "preamble": [],
      "heading": "ENKELSIDAN",
      "grouping": "none",
      "keywords": [
        "TOPP",
        "BOTTEN",
        "SIDOTEXT",
        "NOTIS",
        "BILDNOTIS",
        "UTROPSTECKEN",
        "SIFFRA",
        "CITAT",
        "SPALTTEXT"
      ],
      "item": {
        "headline": "{keyword} {headline}",
        "lines": []
      }
    }
  ]
}
